import { computed, defineComponent, onBeforeMount, onMounted, ref } from 'vue';
import { mediaQuery } from '../../scripts/lib/mediaQuery.js';
import EventBus from '../../scripts/lib/EventBus.js';
import { readJsonFromDom } from '../../scripts/utils.js';

interface BadgeFlagData {
  newItems: string[];
}

const flags = mediaQuery as unknown as Record<string, boolean>;

const templateElement = document.getElementById('badge-liste-template');
export default defineComponent({
  template: templateElement ? templateElement.innerHTML : '',

  props: {
    certifiedColumns: {
      type: Array,
      required: false,
    },
    saleFlagContent: {
      type: String,
      required: false,
    },
    blackWeek: {
      type: Boolean,
      required: false,
    },
    active: {
      type: Object,
      required: true,
    },
    previewArticle: {
      type: Object,
      required: false,
    },
    isEasyIron: {
      type: Boolean,
      required: false,
    },
  },

  setup(props) {
    const isMobileViewport = ref(flags.up_to_L);
    const neuFlagData = ref<BadgeFlagData | null>(null);

    const isNew = computed(() => {
      if (props.active.colors) {
        return (neuFlagData.value as BadgeFlagData).newItems.includes(
          props.previewArticle ? props.previewArticle.colors.active.colorId : props.active.colors.active.colorId,
        );
      }
      return (neuFlagData.value as BadgeFlagData).newItems.includes(props.active.salesId);
    });

    onBeforeMount(() => {
      neuFlagData.value = readJsonFromDom<BadgeFlagData>('#entsBadgeData');
      mediaQuery.on('change:width', () => {
        isMobileViewport.value = flags.up_to_L;
      });
    });

    onMounted(() => {
      EventBus.emit('ents:vue:flags:update', {
        isEasyIron: props.isEasyIron,
        isNew: isNew.value,
      });
    });

    const openCertifiedDrawer = () => {
      EventBus.emit('ents:vue:certified-columns:drawer:open');
    };

    return {
      isNew,
      isMobileViewport,
      neuFlagData,
      openCertifiedDrawer,
    };
  },
});
